import './style.css';

import * as THREE from 'three';
import gsap from 'gsap';
import * as dat from 'lil-gui'

//POSTPROCESSING
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js'
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'

// CAMERA MODELS
import CameraControls from 'camera-controls';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { InteractionManager } from "three.interactive";
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader.js';

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader.js';
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';

import { Sky } from 'three/examples/jsm/objects/Sky.js';

import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';


// Fireflies
import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'
// portal
import portalVertexShader from './shaders/portal/vertex.glsl'
import portalFragmentShader from './shaders/portal/fragment.glsl'

//shaders distortion
import distortVertexShader from './shaders/distort/vertexParticies.glsl'
import distortFragmentShader from './shaders/distort/fragment.glsl'

//shaders wave
import waveVertexShader from './shaders/wave/vertex.glsl'
import waveFragmentShader from './shaders/wave/fragment.glsl'
//import { info } from 'console';




// import hasTouch from 'utils/hasTouch';

const TWEEN = require('@tweenjs/tween.js');
const circle_sprite = new THREE.TextureLoader().load(
	'https://fastforwardlabs.github.io/visualization_assets/circle-sprite.png'
  );

CameraControls.install( { THREE: THREE } );
const loaderPLY = new PLYLoader();
//Smoke Particles
let smokeMaterial, smokeParticles = [];


/*
var sec0 = document.getElementById("section0");
var sec1 = document.getElementById("section1");
var sec2 = document.getElementById("section2");
var sec3 = document.getElementById("section3");
var sec4 = document.getElementById("section4");
*/

var welcome = document.getElementById("welcome");
var blink = document.getElementById("blink");

var exploringBox = document.getElementById("exploring");
var rightBox = document.getElementById("right");
var titleBox = document.getElementById("title");
var plusBtn = document.getElementById("plusBtn");
var minusBtn = document.getElementById("minusBtn");
var leftBtn = document.getElementById("leftBtn");

var rightBtn = document.getElementById("rightBtn");
var exitBtn = document.getElementById("exitBtn");

var tour = document.getElementById("tour");
tour.style.display = "none";

  var teleport = document.getElementById("teleport");
  teleport.style.display = "none";

    var bottom = document.getElementById("bottom");
  var reset = document.getElementById("reset");
  reset.style.display = "none";

  var move = document.getElementById("move");
  var fit = document.getElementById("fit");
  var speedUp = document.getElementById("speedUp");
  speedUp.style.display = "none";
 // var speedDown = document.getElementById("speedDown");
  var t2k = document.getElementById("2k");
  var t4k = document.getElementById("4k");
  // Get the modal
  var infoModal = document.getElementById("infoModal");
  var desertModal = document.getElementById("desertModal");
  var nonameModal = document.getElementById("nonameModal");
  var noendModal = document.getElementById("noendModal");
  var introModal = document.getElementById("introModal");
  var homeModal = document.getElementById("homeModal");

  // Get the button that opens the modal
  var btn = document.getElementById("myBtn");
  var mutebtn = document.getElementById("muteBtn");
  var muted = false
  var home = document.getElementById("home")
  home.style.display = "none";
  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  var span1 = document.getElementsByClassName("close")[1];
  var span2 = document.getElementsByClassName("close")[2];
  var span3 = document.getElementsByClassName("close")[3];
  var span4 = document.getElementsByClassName("close")[4];
  var span5 = document.getElementsByClassName("close")[5];
  var span6 = document.getElementsByClassName("close")[6];

  var goto0 = document.getElementsByClassName("goto")[0];
  var goto1 = document.getElementsByClassName("goto")[1];
  var goto2 = document.getElementsByClassName("goto")[2];
  var goto3 = document.getElementsByClassName("goto")[3];
  var goto4 = document.getElementsByClassName("goto")[4];
  var goto5 = document.getElementsByClassName("goto")[5];
  var goto6 = document.getElementsByClassName("goto")[6];
  var goto7 = document.getElementsByClassName("goto")[7];
  var goto8 = document.getElementsByClassName("goto")[8];
  var goto9 = document.getElementsByClassName("goto")[9];
  
  var muteBtnButton = document.getElementById('muteBtn');

  var aboutButton = document.getElementById('myBtn');





/*
view problem: 
Another possible reason is that certain model parts are discarded by the renderer because of view frustum culling. Try to traverse through your glTF asset and set frustumCulled to false for all objects. gltf.scene.traverse( function( object ) { object.frustumCulled = false; } );

*/

/**
 * Fireflies
 */
// Material
const firefliesMaterial = new THREE.ShaderMaterial({
  uniforms:
  {
      uTime: { value: 0 },
      uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
      uSize: { value: 500 }
  },
  vertexShader: firefliesVertexShader,
  fragmentShader: firefliesFragmentShader,
  transparent: true,
  blending: THREE.AdditiveBlending,
  depthWrite: true
})

function fireflies() {
  // Geometry
  const firefliesGeometry = new THREE.BufferGeometry()
  const firefliesCount = 200
  const positionArray = new Float32Array(firefliesCount * 3)
  const scaleArray = new Float32Array(firefliesCount)

  for(let i = 0; i < firefliesCount; i++)
  {
      positionArray[i * 3 + 0] = (Math.random() - 0.5) * 55
      positionArray[i * 3 + 1] = Math.random() * 5.5
      positionArray[i * 3 + 2] = (Math.random() - 0.5) * 55

      scaleArray[i] = Math.random()
  }

  firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))
  firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1))

  // Points
  const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial)
  
  scene.add(fireflies)
  fireflies.frustumCulled = false;
  fireflies.traverse(function(obj) { obj.frustumCulled = false; });
}


function mraky() {
  const loader = new THREE.TextureLoader();

  loader.crossOrigin = '';

  loader.load(
      'https://s3-us-west-2.amazonaws.com/s.cdpn.io/82015/blue-smoke.png',
      function onLoad(texture) {
          const smokeGeo = new THREE.PlaneBufferGeometry(350, 350);

          smokeMaterial = new THREE.MeshLambertMaterial({
              map: texture,
              transparent: true
          });

          for (let p = 0, l = 120; p < l; p++) {
              let particle = new THREE.Mesh(smokeGeo, smokeMaterial);

              particle.position.set(
                  Math.random() * (300 + 300) -300,
                  Math.random() * (30 + 150) + 30,
                  Math.random() * (300 + 300) - 300
                 // Math.random() * (max - min) + min;
              );

              particle.rotation.x = THREE.MathUtils.degToRad( 90 + Math.random() * 15 )
           //  particle.rotation.x = Math.random() * THREE.MathUtils.degToRad( 30 );
              particle.rotation.z = Math.random() * THREE.MathUtils.degToRad( 60 );
              scene.add(particle);
              smokeParticles.push(particle);
          }

        //  animate();
      }
  );

};


let sky, sun;

function initSky() {

  // Add Sky
  sky = new Sky();
  sky.scale.setScalar( 450000 );
  scene.add( sky );

  sun = new THREE.Vector3();

  /// GUI

  const effectController = {
    turbidity: 18,
    rayleigh: 0.11,
    mieCoefficient: 0.002,
    mieDirectionalG: 0.863,
    elevation: -90,
    azimuth: -170,
    exposure: renderer.toneMappingExposure
  };


    const uniforms = sky.material.uniforms;
    uniforms[ 'turbidity' ].value = effectController.turbidity;
    uniforms[ 'rayleigh' ].value = effectController.rayleigh;
    uniforms[ 'mieCoefficient' ].value = effectController.mieCoefficient;
    uniforms[ 'mieDirectionalG' ].value = effectController.mieDirectionalG;

    const phi = THREE.MathUtils.degToRad( 90 - effectController.elevation );
    const theta = THREE.MathUtils.degToRad( effectController.azimuth );

    sun.setFromSphericalCoords( 1, phi, theta );

    uniforms[ 'sunPosition' ].value.copy( sun );
/*
    renderer.toneMappingExposure = 0.0001;  //0, 1, 0.0001
    renderer.render( scene, camera );

*/


}
//////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////
/**
 * Loaders
 */
 const loadingBarElement = document.querySelector('.loading-bar')
 let sceneReady = false
 let pause = false
 var mixerJehlan
var tween
var readyAfterLoad = false
const loadingManager = new THREE.LoadingManager(
     // Loaded
     () =>
     {
         
         // Wait a little
         window.setTimeout(() =>
         {
             // Animate overlay
             gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })
 
             // Update loadingBarElement
             loadingBarElement.classList.add('ended')
             loadingBarElement.style.transform = ''
            // console.log("ENDED")
             readyAfterLoad = true
             afterLoeadEnded()
         }, 500)

         window.setTimeout(() =>
         {
             sceneReady = true


         }, 500)

     },

     // Progress
     (itemUrl, itemsLoaded, itemsTotal) =>
     {
         // Calculate the progress and update the loadingBarElement
         const progressRatio = itemsLoaded / itemsTotal
         loadingBarElement.style.transform = `scaleX(${progressRatio})`
        // console.log('READY')
         
         cameraControlOnStart()

        
    }
 )





 const gltfLoader = new GLTFLoader(loadingManager)
 const dracoLoader = new DRACOLoader();
 dracoLoader.setDecoderPath( 'three/examples/js/libs/draco/gltf/' );
 gltfLoader.setDRACOLoader( dracoLoader );
 
 const cubeTextureLoader = new THREE.CubeTextureLoader()
 const textureLoader = new THREE.TextureLoader()

 /**
 * Update all materials
 */
const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        {
            child.material.envMapIntensity = 2.5
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}



const _box = new THREE.Box3();
const _vec3 = new THREE.Vector3();
function computeBoundingSphere( object3d ) {
	// var meshCount = 0;
	const points = [];
	const boundingSphere = new THREE.Sphere();
	const center = boundingSphere.center;
	// find the center
	object3d.traverse( function( object ) {
		if ( ! object.isMesh ) return;
		_box.expandByObject( object );
	} );
	_box.getCenter( center );

	// find the radius
	var maxRadiusSq = 0;
	object3d.traverse( function( object ) {
		if ( ! object.isMesh ) return;
		const position = object.geometry.attributes.position;
		for ( var i = 0, l = position.count; i < l; i ++ ) {
			_vec3.fromBufferAttribute( position, i );
			maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vec3 ) );
		}
	} );
	boundingSphere.radius = Math.sqrt( maxRadiusSq );
	return boundingSphere;
}


/*
CANVAS
*/
const canvas = document.querySelector('canvas.webgl')

/*
 SIZES
 */
 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))



})

let generatedCubeRenderTarget, ldrCubeRenderTarget, hdrCubeRenderTarget, rgbmCubeRenderTarget;
let ldrCubeMap, hdrCubeMap, rgbmCubeMap;


/**
 * Renderer
 */
    const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
   // renderer.domElement.addEventListener("click", onclick, true);

    renderer.physicallyCorrectLights = true;

    //Shadow
    renderer.shadowMap.enabled = true; 
    renderer.shadowMapSoft = true; // Shadow
    renderer.shadowMap.type = THREE.PCFShadowMap; //Shadow
    renderer.physicallyCorrectLights = true

  // tonemapping
	//  renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 10.8;

   renderer.outputEncoding = THREE.sRGBEncoding;
  
 
/**
 * CAMERA CAMERA
 * 
 * * MODEL rendering glitch is caused by too low value of near camera plane
 */
 const camera = new THREE.PerspectiveCamera(
      70, sizes.width / sizes.height, 0.005, 600 );
 camera.position.set( 0, 0, 2.5 );

 let movSpeed = 2.0

/*
SCENE
*/
let cubeMap;

//const newEnvMap = renderTarget ? renderTarget.texture : null;

const scene  = new THREE.Scene();
const clock = new THREE.Clock();
document.body.style.cursor = 'default';

// scene.background = new THREE.Color( 0xffffff );




/*
 LIGHTS
  */ 
/*
 const ambientLight = new THREE.AmbientLight(0xffffff, 2.8)
 scene.add(ambientLight)
 
 const directionalLight = new THREE.DirectionalLight(0xffffff, 3)
 directionalLight.castShadow = true
 directionalLight.shadow.mapSize.set(1024, 1024)
 directionalLight.shadow.camera.far = 15
 directionalLight.shadow.normalBias = 0.05
 directionalLight.position.set(0.25, -10, - 2.25)
 //directionalLight.position.set(- 5, 10, 0)
 // scene.add(directionalLight)
*/
 const ambientLight = new THREE.AmbientLight(0xffffff, 5.8)
 scene.add(ambientLight)
 
 const directionalLight = new THREE.DirectionalLight(0x00ffff, 0.6)
 directionalLight.castShadow = true
 directionalLight.shadow.mapSize.set(1024, 1024)
 directionalLight.shadow.camera.far = 15
 directionalLight.shadow.camera.left = - 7
 directionalLight.shadow.camera.top = 7
 directionalLight.shadow.camera.right = 7
 directionalLight.shadow.camera.bottom = - 7
 directionalLight.position.set(- 5, 5, 0)
 scene.add(directionalLight)
/*
POSTPROCESSING
*/
let RenderTargetClass = null

if(renderer.getPixelRatio() === 1 && renderer.capabilities.isWebGL2)
{
    RenderTargetClass = THREE.WebGLMultisampleRenderTarget
  //  console.log('Using WebGLMultisampleRenderTarget')
}
else
{
    RenderTargetClass = THREE.WebGLRenderTarget
  //  RenderTargetClass = new THREE.WebGLRenderer( { alpha: true } );
  //  console.log('Using WebGLRenderTarget')
}

const renderTarget = new RenderTargetClass(
    800,
    600,
    {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat
    }
)
//cubeMap = hdrCubeMap;

//renderTarget = hdrCubeRenderTarget;
//cubeMap = hdrCubeMap;



// Effect composer
const effectComposer = new EffectComposer(renderer, renderTarget)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
effectComposer.setSize(sizes.width, sizes.height)

// Render pass
const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

// Dot screen pass
// const dotScreenPass = new DotScreenPass()
// dotScreenPass.enabled = false
// effectComposer.addPass(dotScreenPass)

// RGB Shift pass
const rgbShiftPass = new ShaderPass(RGBShiftShader)
rgbShiftPass.enabled = false
rgbShiftPass.amount = 4.0
effectComposer.addPass(rgbShiftPass)

// Gamma correction pass
const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader)
effectComposer.addPass(gammaCorrectionPass)

// Antialias pass
if(renderer.getPixelRatio() === 1 && !renderer.capabilities.isWebGL2)
{
    const smaaPass = new SMAAPass()
    effectComposer.addPass(smaaPass)

  //  console.log('Using SMAA')
}

// Unreal Bloom pass
const unrealBloomPass = new UnrealBloomPass()
unrealBloomPass.enabled = true
effectComposer.addPass(unrealBloomPass)

unrealBloomPass.strength = 0.5
unrealBloomPass.radius = 0.5
unrealBloomPass.threshold = 0.8

// Tin pass
const TintShader = {
  uniforms:
  {
      tDiffuse: { value: null },
      uTint: { value: null }
  },
  vertexShader: `
      varying vec2 vUv;

      void main()
      {
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);

          vUv = uv;
      }
  `,
  fragmentShader: `
      uniform sampler2D tDiffuse;
      uniform vec3 uTint;

      varying vec2 vUv;

      void main()
      {
          vec4 color = texture2D(tDiffuse, vUv);
          color.rgb += uTint;

          gl_FragColor = color;
      }
  `
}

const tintPass = new ShaderPass(TintShader)
tintPass.material.uniforms.uTint.value = new THREE.Vector3()
effectComposer.addPass(tintPass)
/*
gui.add(tintPass.material.uniforms.uTint.value, 'x').min(- 1).max(1).step(0.001).name('red')
gui.add(tintPass.material.uniforms.uTint.value, 'y').min(- 1).max(1).step(0.001).name('green')
gui.add(tintPass.material.uniforms.uTint.value, 'z').min(- 1).max(1).step(0.001).name('blue')
*/
// Displacement pass
const DisplacementShader = {
  uniforms:
  {
      tDiffuse: { value: null },
      uTime: { value: null },
      uNormalMap: { value: null }
  },
  vertexShader: `
      varying vec2 vUv;

      void main()
      {
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);

          vUv = uv;
      }
  `,
  fragmentShader: `
      uniform sampler2D tDiffuse;
      uniform float uTime;
      uniform sampler2D uNormalMap;

      varying vec2 vUv;

      void main()
      {
          vec3 normalColor = texture2D(uNormalMap, vUv).xyz * 2.0 - 1.0;
          vec2 newUv = vUv + normalColor.xy * 0.1;
          vec4 color = texture2D(tDiffuse, newUv);

          vec3 lightDirection = normalize(vec3(- 1.0, 1.0, 0.0));
          float lightness = clamp(dot(normalColor, lightDirection), 0.0, 1.0);
          color.rgb += lightness * 2.0;

          gl_FragColor = color;
      }
  `
}
/*
const displacementPass = new ShaderPass(DisplacementShader)
displacementPass.material.uniforms.uTime.value = 0
displacementPass.material.uniforms.uNormalMap.value = textureLoader.load('/textures/interfaceNormalMap.png')
displacementPass.enabled = false
effectComposer.addPass(displacementPass)
*/



// ___________________________________________________________________________________________________________
// ___________________________________________________________________________________________________________
// ___________________________________________________________________________________________________________
// ___________________________________________________________________________________________________________








/**
 * Loaders
 */
 THREE.DefaultLoadingManager.onLoad = function ( ) {

  pmremGenerator.dispose();

};

const hdrUrls = [ 'px.hdr', 'nx.hdr', 'py.hdr', 'ny.hdr', 'pz.hdr', 'nz.hdr' ];

hdrCubeMap = new HDRCubeTextureLoader()
  //.setPath( './textures/cube/pisaHDR/' )
  .setPath( './textures/cube/pisaHDR/' )
  
  .load( hdrUrls, function () {

    hdrCubeRenderTarget = pmremGenerator.fromCubemap( hdrCubeMap );

    hdrCubeMap.magFilter = THREE.LinearFilter;
    hdrCubeMap.needsUpdate = false;

  } );


const pmremGenerator = new THREE.PMREMGenerator( renderer );
pmremGenerator.compileCubemapShader();

const envScene = new DebugEnvironment();
generatedCubeRenderTarget = pmremGenerator.fromScene( envScene );


/*
Interactive manager
*/
const interactionManager = new InteractionManager(
    renderer,
    camera,
    renderer.domElement
  );
  const logDiv = document.querySelector('#bottom .log');
  const objDiv = document.querySelector('#center');
  const modeDiv = document.querySelector('#bottom .mode');
/**
 * Overlay
 */
 const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
 const overlayMaterial = new THREE.ShaderMaterial({
      wireframe: false,
     transparent: true,
     uniforms:
     {
         uAlpha: { value: 0.5 }
     },
     vertexShader: `
         void main()
         {
             gl_Position = vec4(position, 1.0);
         }
     `,
     fragmentShader: `
         uniform float uAlpha;
 
         void main()
         {
             gl_FragColor = vec4(1.0, 1.0, 1.0, uAlpha);
         }
     `
 })
 const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
 scene.add(overlay)


/*
C C C Camera Control  C C C
*/
const cameraControls = new CameraControls( camera, renderer.domElement );
cameraControls.moveTo( 0,15,-55, true )
//cameraControls.rotate( 180 * THREE.MathUtils.DEG2RAD, 0, true )

  var moveForward = false;
  var moveBackward = false;
  var moveLeft = false;
  var moveRight = false

  var exploring = false;
 // modeDiv.innerHTML = '<span style="color: #ffffff"> EXPLORING = ' + exploring + ' </span>';
      
 






 /*
 HANDLE MOUSE
 */
  document.onpointerdown = function(event) {
    switch ( event.button ) {
        case 0:// console.log("Left Button is down."); 
            if (moveEnabled)
                moveForward = true;
            else 
               moveForward = false;
            break;
        case 1:// console.log("Middle Button is down."); 
        //Beware this work not on mac with magic mouse!
            break;
        case 2:// console.log("Right Button is down.");
            break;
    }
}
document.onpointerup = function(event) {
  switch ( event.button ) {
      case 0: //console.log("Left Button is up.");
          if (moveEnabled)
              moveForward = false;
          else 
              moveForward = false;
          break;
      case 1: //console.log("Middle Button is up."); 
      //Beware this work not on mac with magic mouse!
          break;
      case 2:// console.log("Right Button is up.");
          break;
  }
}
/*
HANDLE KEYBOARD
*/
const onKeyDown = function ( event ) {
  switch ( event.code ) {
      case 'ArrowUp':
      case 'KeyW':
          if (moveEnabled)
            moveForward = true;
          else 
            moveForward = false;
          break;
      case 'ArrowLeft':
      case 'KeyA':
            if (moveEnabled)
            moveLeft = true;
          else 
          moveLeft = false;
        //  moveLeft = true;
          break;
      case 'ArrowDown':
      case 'KeyS':
              if (moveEnabled)
              moveBackward = true;
            else 
            moveBackward = false;
        //  moveBackward = true;
          break;
      case 'ArrowRight':
      case 'KeyD':
              if (moveEnabled)
              moveRight = true;
            else 
            moveRight = false;
        //  moveRight = true;
          break;
      case 'Space':
        //  if ( canJump === true ) velocity.y += 150;
        //  canJump = false;
          break;
  }
};
const onKeyUp = function ( event ) {
  switch ( event.code ) {
      case 'ArrowUp':
      case 'KeyW':
        if (moveEnabled)
          moveForward = false;
        else 
          moveForward = false;
      break;
          break;
      case 'ArrowLeft':
      case 'KeyA':
              if (moveEnabled)
              moveLeft = false;
            else 
            moveLeft = false;
        //  moveLeft = false;
          break;
      case 'ArrowDown':
      case 'KeyS':
              if (moveEnabled)
              moveBackward = false;
            else 
            moveBackward = false;
        //  moveBackward = false;
          break;
      case 'ArrowRight':
      case 'KeyD':
              if (moveEnabled)
              moveRight = false;
            else 
            moveRight = false;
        //  moveRight = false;
          break;
  }
};
document.addEventListener( 'keydown', onKeyDown );
document.addEventListener( 'keyup', onKeyUp );




/*
const wKey = new holdEvent.KeyboardKeyHold( KEYCODE.W, 16.666 );

wKey.addEventListener( 'holding', function( event ) { cameraControls.forward(   0.01 * event.deltaTime, false ) } );

const upKey    = new holdEvent.KeyboardKeyHold( KEYCODE.ARROW_UP,    100 );

upKey.addEventListener   ( 'holding', function( event ) { cameraControls.rotate( 0, - 0.05 * THREE.MathUtils.DEG2RAD * event.deltaTime, true ) } );
*/





/*
const waveMat = new THREE.ShaderMaterial({
  map: circle_sprite,
  uniforms:  {	
    pointTexture: { value: circle_sprite },
    time: {	type: "f", value: 1.	},
    screenWidth: { type: "f", value: screenWidth},
    screenHeight: {type: "f", value: screenHeight},
},
  wireframe: true,  transparent: true,
  vertexColors: true,
  vertexColors: THREE.FaceColors,
  vertexColors: THREE.VertexColors,
  vertexShader: waveVertexShader,
  fragmentShader: waveFragmentShader
});

const distortMat = new THREE.ShaderMaterial({
extensions: {
    derivatives: "#extension GL_OES_standard_derivatives : enable"
},
side: THREE.DoubleSide,
uniforms:   {	
    pointTexture: { value: circle_sprite },
    time: {	type: "f", value: 0	},
    mousePos : { type: "v3", value: new THREE.Vector3(0,0,0) },
    pixels: {
        type: "v2",
        value: new THREE.Vector2(window.innerWidth,window.innerHeight)
    },
    uvRate1: {
        value: new THREE.Vector2(1, 1)
    },
    screenWidth: { type: "f", value: screenWidth},
    screenHeight: {type: "f", value: screenHeight},
},
map: circle_sprite,
wireframe: true,  transparent: true,
vertexColors: true,
vertexColors: THREE.FaceColors,
vertexColors: THREE.VertexColors,
vertexShader: distortVertexShader,
fragmentShader: distortFragmentShader
});
*/

function rotateObject(object, degreeX=0, degreeY=0, degreeZ=0) {
  object.rotateX(THREE.Math.degToRad(degreeX));
  object.rotateY(THREE.Math.degToRad(degreeY));
  object.rotateZ(THREE.Math.degToRad(degreeZ));
}

////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   

var mouse = new THREE.Vector2();
var mousePos = new THREE.Vector3()

////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   
////   EEE      EEE      EEE      EEE      EEE      EEE      EEE      EEE   


  //////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////

//////////////         ////           ////      ////           //////
///////                //////////     ////        ////       ////
//////////////         ////   /////   ////         ////     ////
//////////////         ////    ////   ////         ////     ////
///////                ////      ////  ///          ////  ////
//////////////         ////        ///////            //////

///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////

//////////////         ////           ////      ////           //////
///////                //////////     ////        ////       ////
//////////////         ////   /////   ////         ////     ////
//////////////         ////    ////   ////         ////     ////
///////                ////      ////  ///          ////  ////
//////////////         ////        ///////            //////

///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////

//////  ////////         ////           ////      ////           //////
///////                //////////     ////        ////       ////
//////////////         ////   /////   ////         ////     ////
//////////////         ////    ////   ////         ////     ////
///////                ////      ////  ///          ////  ////
//////////////         ////        ///////            //////

///////////////////////////////////////////////////////////////////////////////

// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss

const portalLightMaterial = new THREE.ShaderMaterial({
  uniforms:
  {
      uTime: { value: 0 },
      uColorStart: { value: new THREE.Color('#880000') },
      uColorEnd: { value: new THREE.Color('#ffffff') }
  },
  vertexShader: portalVertexShader,
  fragmentShader: portalFragmentShader
})
const portalLightMaterial1 = new THREE.ShaderMaterial({
uniforms:
{
    uTime: { value: 0 },
    uColorStart: { value: new THREE.Color('#888800') },
    uColorEnd: { value: new THREE.Color('#ffffff') }
},
vertexShader: portalVertexShader,
fragmentShader: portalFragmentShader
})
const portalLightMaterial2 = new THREE.ShaderMaterial({
uniforms:
{
    uTime: { value: 0 },
    uColorStart: { value: new THREE.Color('#880088') },
    uColorEnd: { value: new THREE.Color('#ffffff') }
},
vertexShader: portalVertexShader,
fragmentShader: portalFragmentShader
})
const portalLightMaterial3 = new THREE.ShaderMaterial({
uniforms:
{
    uTime: { value: 0 },
    uColorStart: { value: new THREE.Color('#000000') },
    uColorEnd: { value: new THREE.Color('#ffffff') }
},
vertexShader: portalVertexShader,
fragmentShader: portalFragmentShader
})


/*
PORTALS PORTALS
*/
let portalMixer
gltfLoader.load('./models/intro/intro_portals.glb', function (
  gltf
) {
  const model = gltf.scene;
  model.position.set(0.0,1.0,0.0);
  model.scale.set(1.0,1.0,1.0);
  model.rotation.set(0,0,0);
  model.scale.multiplyScalar( 1.0 );
  scene.add(model);


  // Animation
  portalMixer = new THREE.AnimationMixer( model );
//  console.log( gltf.animations );
  const numAnim =  gltf.animations.length - 1
//  console.log("Portals Animation Length: " + (numAnim+1) );

 // portalMixer.timeScale = 0.1

  for(let i = numAnim; i >= 0; i--)
  {
    portalMixer.clipAction( gltf.animations[ i ] ).play();
 // sceneMixer.clipAction( gltf.animations[ i ] ).loop = THREE.LoopOnce;
 portalMixer.clipAction( gltf.animations[ i ] ).loop = THREE.LoopRepeat;
      // .setLoop(LoopPingPong)
  
}


 // Get each object
    //    const bakedMesh = gltf.scene.children.find((child) => child.name === 'baked')
        const portalLightMesh = gltf.scene.children.find((child) => child.name === 'spacedesertPortal')
        const portalLightMesh1 = gltf.scene.children.find((child) => child.name === 'nonamePortal')
        const portalLightMesh2 = gltf.scene.children.find((child) => child.name === 'noendPortal')

     //   const poleLightAMesh = gltf.scene.children.find((child) => child.name === 'poleLightA')
     //   const poleLightBMesh = gltf.scene.children.find((child) => child.name === 'poleLightB')

        // Apply materials
      //  bakedMesh.material = bakedMaterial
        portalLightMesh.material = portalLightMaterial
        portalLightMesh1.material = portalLightMaterial1
        portalLightMesh2.material = portalLightMaterial2

     //   poleLightAMesh.material = poleLightMaterial
     //   poleLightBMesh.material = poleLightMaterial

  let objectsHover = [];

  model.traverse((child) => {
    if (pause == false){
      if (child.children.length === 0) {
      // Add only objects widthout children
      if (child.material) {
       // child.material = child.material.clone();
       // child.userData.initialEmissive = child.material.emissive.clone();
       // child.material.emissiveIntensity = 0.5;
      }

      interactionManager.add(child);

      child.addEventListener('mouseover', (event) => {
                  if (!objectsHover.includes(event.target))
                    objectsHover.push(event.target);
                  document.body.style.cursor = 'pointer';
                  
                //  const path = getPath(event.target);
                //  logDiv.innerHTML =
                //    '<span style="color: #000000">' + path + ' – mouseover</span>';
                
                    if (event.target.name === "spacedesertPortal") {

                      portalLightMesh.material = portalLightMaterial3
                      //  console.log("HOLE mouse over");
                        objDiv.innerHTML =
                    '<div class="bublina"><p style="color: #000000"> Space desert - Viktoria Remiarova</p></div>';
                    } 
                    else if (event.target.name === "nonamePortal") {

                      portalLightMesh1.material = portalLightMaterial3
                    //  console.log("HOLE mouse over");
                      objDiv.innerHTML =
                  '<div class="bublina"><p style="color: #000000"> NO NAME - Martin Lukáč</p></div>';
                  }
                  else if (event.target.name === "noendPortal") {

                    portalLightMesh2.material = portalLightMaterial3
                  //  console.log("WTF");
                    objDiv.innerHTML =
                '<div class="bublina"><p style="color: #000000"> There is no beginning or end! - Lu Jindrak Skrivankova</p></div>';
            }
              if (child.material) {
                //  child.userData.materialEmissiveHex = child.material.emissive.getHex();
                //  child.material.emissive.setHex(0x000000);
                //  child.material.emissiveIntensity = 0.5;
              }
      });

      child.addEventListener('mouseout', (event) => {
                  objectsHover = objectsHover.filter((n) => n !== event.target);
                  if (objectsHover.length > 0) {
                    const o = objectsHover[objectsHover.length - 1];
                //   o.material.emissive.setHex(0xff0000);
                    logDiv.innerHTML = getPath(o);
                  } else {
                    logDiv.innerHTML = '';
                  }
                  document.body.style.cursor = 'default';
                  if (child.material) {
                  //  child.material.emissive.setHex(
                  //   child.userData.materialEmissiveHex
                  //  );
                  }

                  if (event.target.name === "spacedesertPortal") {

                    portalLightMesh.material = portalLightMaterial
                    //  console.log("HOLE mouse over");
                      objDiv.innerHTML =
                  '<div class="bublina" style="display: none"><p style="color: #000000"> This will teleport you to Desert realm.</p></div>';
                  } 
                  else if (event.target.name === "nonamePortal") {

                    portalLightMesh1.material = portalLightMaterial1
                  //  console.log("HOLE mouse over");
                    objDiv.innerHTML =
                '<div class="bublina" style="display: none"><p style="color: #000000"> This will teleport you to NoName realm.</p></div>';
                }
                else if (event.target.name === "noendPortal") {

                  portalLightMesh2.material = portalLightMaterial2
                //  console.log("HOLE mouse over");
                  objDiv.innerHTML =
              '<div class="bublina" style="display: none"><p style="color: #000000"> This will teleport you to NoEnd realm.</p></div>';
          }
      });

      child.addEventListener('mousedown', (event) => {
        
          if (event.target.name === "spacedesertPortal") {
            AudioClick()
            // console.log("holeWasClicked");
             desertModal.style.display = "block";
             pause = true
          //  var myWindow = window.open("../desert/index.html", "_self");
            pause = true
            window.setTimeout(() =>
            {        }, 5000)
          }

          else if (event.target.name === "nonamePortal") {
            AudioClick()
          //  console.log("holeWasClicked");
            nonameModal.style.display = "block";
              pause = true
        //   var myWindow = window.open("../noname/index.html", "_self");
           pause = true
           window.setTimeout(() =>
           {        }, 5000)
         }

         else if (event.target.name === "noendPortal") {
          AudioClick()
        //  console.log("holeWasClicked");
          noendModal.style.display = "block";
              pause = true
      //   var myWindow = window.open("../noend/index.html", "_self");  
         pause = true
         window.setTimeout(() =>
         {        }, 5000)
       }

      //  const path = getPath(event.target);
      //  logDiv.innerHTML =
      //    '<span style="color: #0000ff">' + path + ' – mousedown</span>';
      });
    }
    }
    
  });
});
//////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////


// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss
// ssssssssssssssssssssssss             sssssssssssssss         ssssssssssssssssssssssssss



  /////////////////////////////////////////////////////////////////////
  let room
  roomline()
  function roomline() {
    // STATIC PLY ROOM PLY
	loaderPLY.load( './models/intro/room.ply', function ( geometry ) {
    room = geometry
		room.computeVertexNormals();
		room.center();
		const material = new THREE.MeshStandardMaterial( { color: 0x0055ff, flatShading: true } );
		const material1 = new THREE.MeshStandardMaterial   ({ 
   //   shininess: 1000,
      vertexColors: THREE.FaceColors,
      wireframe: true
  } );
  material1.wireframe = true

    room = new THREE.Mesh( room, material1 );
  //  room.position.set(-300,0,-100)
    room.position.set(-200,0,-0)
    rotateObject(room, 90,0,270)
    room.scale.multiplyScalar(3.0);
    room.castShadow = true;
    room.receiveShadow = true; 
		scene.add( room );

    //		mesh.rotation.x = - Math.PI / 2;
   	//	mesh.position.y = -5.;
	//	mesh.position.z = -75; 
   // mesh.rotateX(THREE.Math.degToRad(90));

		var pointsMaterialRoom = new THREE.PointsMaterial({
			vertexColors: THREE.FaceColors,
		//	size: (factor * circleRadius) / fov,	
			sizeAttenuation: false,
			vertexColors: true,
			map: circle_sprite,
			transparent: true,
			opacity: 0.8,
			size: 10.0

		});
		var points = new THREE.Points(room.geometry, pointsMaterialRoom);
    points.position.set(-1.5,3.5,0.0);
    points.scale.set(1.0,1.0,1.0);
    points.rotation.x = Math.PI / 2   // Math.PI * 2;
		points.rotation.y = Math.PI //- Math.PI / 1;
    points.rotation.z = Math.PI // Math.PI * 2;
    
    points.scale.multiplyScalar( 0.1 );
		
  //		scene.add(points);
	} );
  }

	
//////////////////////////////////////////////////////////////////////////////////////////////////
//// test//// test//// test//// test//// test//// test//// test//// test//// test//// test
/*
loaderPLY.load( './models/intro/room.ply', function ( geometry ) {
    
  geometry.computeVertexNormals();
  geometry.center();
  const material = new THREE.MeshStandardMaterial( { color: 0x0055ff, flatShading: true } );
  const material1 = new THREE.MeshStandardMaterial           ({ shininess: 1000,vertexColors: THREE.FaceColors } );
  const mesh = new THREE.Mesh( geometry, material1 );
  mesh.castShadow = true;
  mesh.receiveShadow = true; 
  //scene.add( mesh );

  var pointsMaterial = new THREE.PointsMaterial({
    vertexColors: THREE.FaceColors,
  //	size: (factor * circleRadius) / fov,	
    sizeAttenuation: false,
    vertexColors: true,
    map: circle_sprite,
    transparent: true,
    opacity: 0.8,
    size: 8.0

  });
  var points = new THREE.Points(mesh.geometry, pointsMaterial);
  points.position.set(-1.5,3.5,0.0);
  points.scale.set(1.0,1.0,1.0);
  points.rotation.x = Math.PI / 2   // Math.PI * 2;
  points.rotation.y = Math.PI //- Math.PI / 1;
  points.rotation.z = Math.PI // Math.PI * 2;
  
  points.scale.multiplyScalar( 0.1 );
  
  // scene.add(points);
} );
*/
//////////////////////////////////////////////////////////////////////////////////////////////////
/*
GLTF INFOS
*/
gltfLoader.load('./models/intro/info.glb', function (
    gltf
  ) {
    const model = gltf.scene;

  //  scene.add(model);

    let objectsHover = [];

    model.traverse((child) => {
      if (pause == false){
        if (child.children.length === 0) {
        // Add only objects widthout children
        if (child.material) {
          child.material = child.material.clone();
          child.userData.initialEmissive = child.material.emissive.clone();
          child.material.emissiveIntensity = 0.5;
        }

        interactionManager.add(child);

        child.addEventListener('mouseover', (event) => {
              if (!objectsHover.includes(event.target))
                objectsHover.push(event.target);

              document.body.style.cursor = 'pointer';        
            //  const path = getPath(event.target);
           //   logDiv.innerHTML =
            //    '<span style="color: #000000">' + path + ' – mouseover</span>';

                if (event.target.name === "info") {
                  //  console.log("info");
                    objDiv.innerHTML =
                '<div class="bublina1"><p style="color: #000000">Info</p></div>';
                } else if (event.target.name === "info001") {
                //  console.log("info1");
                  objDiv.innerHTML =
              '<div class="bublina1"><p style="color: #000000">Info</p></div>';
              } else if (event.target.name === "info002") {
                 //   console.log("info2");
                    objDiv.innerHTML =
                '<div class="bublina1"><p style="color: #000000">Info</p></div>';
                } else {
                  //  objDiv.innerHTML = ""
                }
              if (child.material) {
                child.userData.materialEmissiveHex = child.material.emissive.getHex();
                child.material.emissive.setHex(0xff0000);
                child.material.emissiveIntensity = 0.5;
              }
        });

        child.addEventListener('mouseout', (event) => {
         //   const path = getPath(event.target);
            objectsHover = objectsHover.filter((n) => n !== event.target);
            if (objectsHover.length > 0) {
              const o = objectsHover[objectsHover.length - 1];
              o.material.emissive.setHex(0xff0000);
          //    logDiv.innerHTML = getPath(o);
            } else {
           //   logDiv.innerHTML = '';
            }
         //   document.body.style.cursor = 'default';

            if (child.material) {
              child.material.emissive.setHex(
                child.userData.materialEmissiveHex
              );
            }

            if (event.target.name === "info") {
              //  console.log("info");
                objDiv.innerHTML =
            '<div class="bublina1" style="display: none"><p style="color: #000000">Info</p></div>';
            } else if (event.target.name === "info001") {
            //  console.log("info1");
              objDiv.innerHTML =
          '<div class="bublina1" style="display: none"><p style="color: #000000">Info</p></div>';
          } else if (event.target.name === "info002") {
             //   console.log("info2");
                objDiv.innerHTML =
            '<div class="bublina1" style="display: none"><p style="color: #000000">Info</p></div>';
            } else {
                objDiv.innerHTML = ""
            }



        });

        child.addEventListener('mousedown', (event) => {

          if (event.target.name === "info") {
              AudioClick()
              //  console.log("info was clicked");
              //    objDiv.innerHTML =
              // '<span style="color: #000000"> Objekt 1 </span>';
              desertModal.style.display = "block";
              pause = true
            //  console.log('Pausa iniciated, Modal on')
              window.setTimeout(() =>
              {
                  
              
              }, 5000)
          }
          else if (event.target.name === "info001") {
              AudioClick()
               // console.log("info001 was clicked");
                nonameModal.style.display = "block";
                pause = true
               // console.log('Pausa iniciated, Modal on')
                window.setTimeout(() =>
                {
                    
                    console.log()
                }, 5000)
            } 
          else if (event.target.name === "info002") {
              AudioClick()
             // console.log("info002 was clicked");
              noendModal.style.display = "block";
              pause = true
             // console.log('Pausa iniciated, Modal on')
              window.setTimeout(() =>
              {
           
              }, 5000)
          }      
            
         // event.stopPropagation();

          if (child.material) {
            child.material.emissive.setHex(0x0000ff);
          }

        //  const path = getPath(event.target);
        //  logDiv.innerHTML =
        //    '<span style="color: #0000ff">' + path + ' – mousedown</span>';
        });
      }
      }
      
    });
  });
//////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////////////////

//////////////         ////           ////      ////           //////
///////                //////////     ////        ////       ////
//////////////         ////   /////   ////         ////     ////
//////////////         ////    ////   ////         ////     ////
///////                ////      ////  ///          ////  ////
//////////////         ////        ///////            //////

///////////////////////////////////////////////////////////////////////////////



const SVGloader = new SVGLoader();

let longText
// load a SVG resource
SVGloader.load(
	// resource URL
	'./textures/info/intro.svg',
	// called when the resource is loaded
	function ( data ) {

		const paths = data.paths;
		longText = new THREE.Group();

		for ( let i = 0; i < paths.length; i ++ ) {

			const path = paths[ i ];

			const material = new THREE.MeshBasicMaterial( {
				color: path.color, //0xffffff
       // color:0x11ff11, //0xffffff
        reflectivity: 0,
				side: THREE.DoubleSide,
				depthWrite: true
			} );

			const shapes = SVGLoader.createShapes( path );

			for ( let j = 0; j < shapes.length; j ++ ) {

				const shape = shapes[ j ];
				const geometry = new THREE.ShapeGeometry( shape );
				const mesh = new THREE.Mesh( geometry, material );
     //   longText = mesh
				longText.add( mesh );

			}

		}
    


    longText.position.set(-11, 28, 80 );
    longText.scale.multiplyScalar(0.4);
		scene.add( longText );
    rotateObject(longText, 180,240,0)
	},
	// called when loading is in progresses
	function ( xhr ) {

	//	console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

	},
	// called when loading has errors
	function ( error ) {

		console.log( 'An error happened' );

	}
);



/*
var mixerDoor
let door

    gltfLoader.load( './models/intro/intro_door.glb', function ( gltf ) {
      door = gltf.scene;

      updateAllMaterials()

      door.position.set(0.0,0.0,0.0);
        gltf.scene.scale.set(1.0,1.0,1.0);
        gltf.scene.rotation.set(0,0,0);
       // gltf.scene.scale.multiplyScalar( 5.0 );  
        scene.add( door );

        const portalLightMesh = gltf.scene.children.find((child) => child.name === 'portal')
        portalLightMesh.material = portalLightMaterial

        door.traverse( function ( object ) {
            if ( object.isMesh ) object.castShadow = true;
        } );

      mixerDoor = new THREE.AnimationMixer( door );
      //  console.log( gltf.animations );
        const numAnim =  gltf.animations.length - 1
        var actualAnim = -1
        console.log("Door Animation Length: " + (numAnim+1) );
       mixerDoor.timeScale = 8.1
       
        mixerDoor.clipAction( gltf.animations[ 1 ] ).setLoop(THREE.LoopOnce); // 
        mixerDoor.clipAction( gltf.animations[ 1 ] ).clampWhenFinished = true;       
        mixerDoor.clipAction( gltf.animations[ 1 ] ).play();  //setLoop(THREE.LoopOnce);
      
        
        for(let i = numAnim; i >= 0; i--)
        {
        //  mixerDoor.clipAction( gltf.animations[ i ] ).play();
        //  mixer1.clipAction( gltf.animations[ i ] ).loop = THREE.LoopOnce;
        }

    let objectsHover = [];
    var target = new THREE.Vector3(); // create once an reuse it

   
    door.traverse((child) => {

        if (child.children.length === 0) {
        // Add only objects widthout children
        if (child.material) {
       //   child.material = child.material.clone();
       //   child.userData.initialEmissive = child.material.emissive.clone();
       //   child.material.emissiveIntensity = 0.5;
        }

        interactionManager.add(child);

        child.addEventListener('mouseover', (event) => {
          if (pause == false) {

            if (event.target.name != "Cube") {
              if (event.target.name != "klub002") {
                if (event.target.name != "klub002") {

                       
               //   child.material.emissive.setHex(0x222222);
                  child.getWorldPosition( target )
        
                  if (!objectsHover.includes(event.target))
                    objectsHover.push(event.target);

                  //  console.log("CHILD POSITION ______: " + target.x + "; " + target.y + "; " + target.z)
                  // console.log(event);  
                 console.log(event.target.name)

                        if (event.target.name === "Door_1") {
                          objDiv.innerHTML =
                          '<div class="bublina" style="display: block"><p style="color: #000000"> Go to Textile Technology</p></div>';
                          document.body.style.cursor = 'pointer'; 

                          console.log("YOU HIT THE DOOR OVER OVER")
                          mixerDoor.clipAction( gltf.animations[ 0 ] ).setLoop(THREE.LoopOnce); // 
                          mixerDoor.clipAction( gltf.animations[ 0 ] ).clampWhenFinished = true;       
                          mixerDoor.clipAction( gltf.animations[ 0 ] ).play(); 
                      } 
                     
                }      
              } 
            }    
            
          }
          interactionManager.update();  
        });

        child.addEventListener('mouseout', (event) => {
          if (pause == false) {

         const path = getPath(event.target);
         if (event.target.name != "Cube") {
          if (event.target.name != "klub002") {
            if (event.target.name != "klub002") {

            
            //ANIM
            if (event.target.name === "Door_1") {
              document.body.style.cursor = 'default';
              objDiv.innerHTML =
                  '<div class="bublina" style="display: none"><p style="color: #000000"> This will teleport you to Desert realm.</p></div>';       
              
              console.log("YOU HIT THE DOOR OUT")
              mixerDoor.clipAction( gltf.animations[ 0 ] ).stop();
              mixerDoor.clipAction( gltf.animations[ 1 ] ).setLoop(THREE.LoopOnce); // 
              mixerDoor.clipAction( gltf.animations[ 1 ] ).clampWhenFinished = true;       
              mixerDoor.clipAction( gltf.animations[ 1 ] ).play(); 
            } 
            
              objectsHover = objectsHover.filter((n) => n !== event.target);
              if (objectsHover.length > 0) {
                const o = objectsHover[objectsHover.length - 1];
          //     o.material.emissive.setHex(0xff0000);
                }
              if (child.material) {
             //   child.material.emissive.setHex(child.userData.materialEmissiveHex);
          }

        }
        }
      }

        }
        interactionManager.update();  
      });

        child.addEventListener('mousedown', (event) => {

          if (pause == false) {

            if (event.target.name != "Cube") {
              if (event.target.name != "Frame") {
                if (event.target.name != "klub002") {

                  if (event.target.name === "Door_1") {
                    AudioClick()
                    var startRotation = new THREE.Euler().copy( camera.rotation );
                    camera.lookAt( child.position );
                    var endRotation = new THREE.Euler().copy( camera.rotation );
                    camera.rotation.copy( startRotation );
                    cameraControls.moveTo( target.x + 1.0, target.y + 2.0, target.z+1.0, true )

                    pause = true
                    window.setTimeout(() =>
                    {   
                      console.log("holeWasClicked");
                      technoModal.style.display = "block";

                     //  var myWindow = window.open("../technology/index.html", "_self");  
                         }, 500)
                  }


              if (child.material) {
            //    child.material.emissive.setHex(0x0000ff); 
              }  
            }
          }
        }

        }
        });
      }
    });
          interactionManager.add(jehlan);
          interactionManager.update();        
    } );
  */
//oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo


/*
// text
var text
gltfLoader.load( './models/intro/intro_logo.glb', function ( gltf ) {

  text = gltf.scene;
  text.scale.multiplyScalar(1.0);
//  modelScene.rotation.x =  Math.PI ;
text.position.set(0.0,0.0,0.0)
  scene.add( text );

//    mixer1 = new THREE.AnimationMixer( model2 );
//    action1 = mixer1.clipAction( gltf.animations[ 0 ] ).play();

  //  convertToPoints();

});
*/





///////////////////////////////////////////////////////////////////////////

//////////////         ////           ////      ////           //////
///////                //////////     ////        ////       ////
//////////////         ////   /////   ////         ////     ////
//////////////         ////    ////   ////         ////     ////
///////                ////      ////  ///          ////  ////
//////////////         ////        ///////            //////

///////////////////////////////////////////////////////////////////////////////

var jehlan
var jehlanHover = false
    gltfLoader.load( './models/intro/introNav.glb', function ( gltf ) {
      jehlan = gltf.scene;

      updateAllMaterials()

      jehlan.position.set(0.0,0.0,0.0);
    //  model2.position.set(2.0,4.0,0.0);
        gltf.scene.scale.set(1.0,1.0,1.0);
        gltf.scene.rotation.set(0,0,0);
       // gltf.scene.scale.multiplyScalar( 5.0 );  
        scene.add( jehlan );
      //  const axesHelper = new THREE.AxesHelper( 5 )
      //  gltf.scene.add( axesHelper );

      jehlan.traverse( function ( object ) {
            if ( object.isMesh ) object.castShadow = true;
        } );

        mixerJehlan = new THREE.AnimationMixer( jehlan );
      //  console.log( gltf.animations );
        const numAnim =  gltf.animations.length - 1
        var actualAnim = -1
      // console.log("Klulbkoports Animation Length: " + (numAnim+1) );

       // mixerJehlan.clipAction( gltf.animations[ 0 ] ).play();

        for(let i = numAnim; i >= 0; i--)
        {
          mixerJehlan.clipAction( gltf.animations[ i ] ).loop = THREE.LoopPingPong;
          // .setLoop(LoopPingPong)
      

        mixerJehlan.clipAction( gltf.animations[ i ] ).play();
       // mixerJehlan.clipAction( gltf.animations[ i ] ).loop = THREE.LoopOnce;
       mixerJehlan.clipAction( gltf.animations[ i ] ).loop = THREE.LoopPingPong
       
        }

    let objectsHover = [];
    var target = new THREE.Vector3(); // create once an reuse it

   
    jehlan.traverse((child) => {

        if (child.children.length === 0) {
        // Add only objects widthout children
        if (child.material) {
          child.material = child.material.clone();
          child.userData.initialEmissive = child.material.emissive.clone();
          child.material.emissiveIntensity = 0.5;
        }

        interactionManager.add(child);
/*
        const controls = new DragControls( objects, camera, renderer.domElement );
        controls.addEventListener( 'dragstart', function ( event ) {

          event.object.material.emissive.set( 0xaaaaaa );
        
        } );
        controls.addEventListener( 'dragend', function ( event ) {

          event.object.material.emissive.set( 0x000000 );
        
        } );
*/
        child.addEventListener('mouseover', (event) => {
          if (pause == false) {
          //  console.log(event.target.name)
            if (event.target.name != "vlakno_A") {
              if (event.target.name != "vlakno_B") {
                if (event.target.name != "vlakno_C") {
                  document.body.style.cursor = 'pointer';      
                  child.material.emissive.setHex(0x222222);
                  child.getWorldPosition( target )
        
                  if (!objectsHover.includes(event.target))
                    objectsHover.push(event.target);
                  //  console.log("CHILD POSITION ______: " + target.x + "; " + target.y + "; " + target.z)
                  // console.log(event);  
                  

                    //ANIM
                    if (event.target.name === "klubkport001") {
                      mixerJehlan.clipAction( gltf.animations[ 0 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 1 ] ).loop = THREE.LoopRepeat
                      
                    } else if (event.target.name === "klubkport002") {
                      mixerJehlan.clipAction( gltf.animations[ 2 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 3 ] ).loop = THREE.LoopRepeat
                      
                    } else if (event.target.name === "klubkport003") {
                    mixerJehlan.clipAction( gltf.animations[ 4 ] ).loop = THREE.LoopRepeat
                    mixerJehlan.clipAction( gltf.animations[ 5 ] ).loop = THREE.LoopRepeat
                    
                    } else if (event.target.name === "klubkport004") {
                      mixerJehlan.clipAction( gltf.animations[ 6 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 7 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport005") {
                      mixerJehlan.clipAction( gltf.animations[ 8 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 9 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport006") {
                      mixerJehlan.clipAction( gltf.animations[ 10 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 11 ] ).loop = THREE.LoopRepeat
                    } 
                    else if (event.target.name === "klubkport007") {
                      mixerJehlan.clipAction( gltf.animations[ 12 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 13 ] ).loop = THREE.LoopRepeat
                    }

                     else if (event.target.name === "klubkport009") {
                      mixerJehlan.clipAction( gltf.animations[ 14 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 15 ] ).loop = THREE.LoopRepeat
                    } 
                    else if (event.target.name === "klubkport008") {
                      mixerJehlan.clipAction( gltf.animations[ 16 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 17 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport010") {
                      mixerJehlan.clipAction( gltf.animations[ 18 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 19 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport011") {
                      mixerJehlan.clipAction( gltf.animations[ 20 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 21 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport012") {
                      mixerJehlan.clipAction( gltf.animations[ 22 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 23 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport013") {
                      mixerJehlan.clipAction( gltf.animations[ 24 ] ).loop = THREE.LoopRepeat;
                      mixerJehlan.clipAction( gltf.animations[ 25 ] ).loop = THREE.LoopRepeat
                    } else if (event.target.name === "klubkport014") {
                      mixerJehlan.clipAction( gltf.animations[ 26 ] ).loop = THREE.LoopRepeat
                      mixerJehlan.clipAction( gltf.animations[ 27 ] ).loop = THREE.LoopRepeat
                    } 
                    //  const path = getPath(event.target);
                    //  logDiv.innerHTML = '<span style="color: #00aa00">' + path + ' – mouseover</span>';
                 
                }      
              } 
            }    
            
          }
        });

        child.addEventListener('mouseout', (event) => {
          if (pause == false) {

        // const path = getPath(event.target);
         if (event.target.name != "vlakno_A") {
          if (event.target.name != "vlakno_B") {
            if (event.target.name != "vlakno_C") {
            document.body.style.cursor = 'default';
            //ANIM
            if (event.target.name === "klubkport001") {
              mixerJehlan.clipAction( gltf.animations[ 0 ] ).loop = THREE.LoopPingPong //  .stop();
              mixerJehlan.clipAction( gltf.animations[ 1 ] ).loop = THREE.LoopPingPong
              
            } else if (event.target.name === "klubkport002") {
              mixerJehlan.clipAction( gltf.animations[ 2 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 3 ] ).loop = THREE.LoopPingPong
              
            } else if (event.target.name === "klubkport003") {
            mixerJehlan.clipAction( gltf.animations[ 4 ] ).loop = THREE.LoopPingPong
            mixerJehlan.clipAction( gltf.animations[ 5 ] ).loop = THREE.LoopPingPong
            
            } else if (event.target.name === "klubkport004") {
              mixerJehlan.clipAction( gltf.animations[ 6 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 7 ] ).loop = THREE.LoopPingPong
            } else if (event.target.name === "klubkport005") {
              mixerJehlan.clipAction( gltf.animations[ 8 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 9 ] ).loop = THREE.LoopPingPong
            }else if (event.target.name === "klubkport006") {
              mixerJehlan.clipAction( gltf.animations[ 10 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 11 ] ).loop = THREE.LoopPingPong
            }
            else if (event.target.name === "klubkport007") {
              mixerJehlan.clipAction( gltf.animations[ 12 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 13 ] ).loop = THREE.LoopPingPong
            }

            else if (event.target.name === "klubkport009") {
              mixerJehlan.clipAction( gltf.animations[ 14 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 15 ] ).loop = THREE.LoopPingPong
            }
            else if (event.target.name === "klubkport008") {
              mixerJehlan.clipAction( gltf.animations[ 16 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 17 ] ).loop = THREE.LoopPingPong
            } else if (event.target.name === "klubkport010") {
              mixerJehlan.clipAction( gltf.animations[ 18 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 19 ] ).loop = THREE.LoopPingPong;
            } else if (event.target.name === "klubkport011") {
              mixerJehlan.clipAction( gltf.animations[ 20 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 21 ] ).loop = THREE.LoopPingPong
            } else if (event.target.name === "klubkport012") {
              mixerJehlan.clipAction( gltf.animations[ 22 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 23 ] ).loop = THREE.LoopPingPong
            } else if (event.target.name === "klubkport013") {
              mixerJehlan.clipAction( gltf.animations[ 24 ] ).loop = THREE.LoopPingPong;
              mixerJehlan.clipAction( gltf.animations[ 25 ] ).loop = THREE.LoopPingPong
            } else if (event.target.name === "klubkport014") {
              mixerJehlan.clipAction( gltf.animations[ 26 ] ).loop = THREE.LoopPingPong
              mixerJehlan.clipAction( gltf.animations[ 27 ] ).loop = THREE.LoopPingPong
            }
              objectsHover = objectsHover.filter((n) => n !== event.target);
              if (objectsHover.length > 0) {
                const o = objectsHover[objectsHover.length - 1];
          //     o.material.emissive.setHex(0xff0000);
              }

              if (child.material) {
                child.material.emissive.setHex(
                  child.userData.materialEmissiveHex
                );
          }

        }
        }
      }

        }
      });

        child.addEventListener('mousedown', (event) => {
          if (pause == false) {

            if (event.target.name != "klub") {
              if (event.target.name != "klub001") {
                if (event.target.name != "klub002") {

              if (child.material) {
            //    child.material.emissive.setHex(0x0000ff); 
              }

                // TWEEN CAMERA POSITION
                AudioClick()
                // backup original rotation
                /*
                var startRotation = new THREE.Euler().copy( camera.rotation );
                const _tmp = new THREE.Vector3();
                _tmp.x = camera.position.x
                _tmp.y = camera.position.y
                _tmp.z = camera.position.z
*/
            //    var lookAtVector = new THREE.Vector3(camera.matrix[8], camera.matrix[9], camera.matrix[10]);
             //   console.log("Look at vector: " +  lookAtVector.x )
             //   console.log("Look at vector: " +  lookAtVector.x + lookAtVector.y + lookAtVector.z)

                
                // final rotation (with lookAt)
           //     camera.lookAt( child.position );
/*
              console.log("x: " + camera.position.x + "y: " + camera.position.y + "z: " + camera.position.z)
              cameraControls.lerpLookAt( camera.position.x,camera.position.y,camera.position.z,
                                          target.x,target.y+2,target.z,
                                          camera.position.x,camera.position.y,camera.position.z,
                                          target.x,target.y+2,target.z,
                                          0,
                                          true )
*/
        //  cameraControls.moveTo( target.x, target.y + 2.0, target.z, true )

            cameraControls.setLookAt( camera.position.x,camera.position.y,camera.position.z,
              target.x,target.y+3,target.z,
              true )
          cameraControls.dollyTo(3.8,true)
            

//            cameraControls.rotate( startRotation.y, 90 * THREE.MathUtils.DEG2RAD, true )

                var endRotation = new THREE.Euler().copy( camera.rotation );
                // revert to original rotation
            //    camera.rotation.copy( startRotation );
               

             //   cameraControls.rotate( 105 * THREE.MathUtils.DEG2RAD, 0, false )

                // Tween
              //  tween = new TWEEN.Tween( camera ).to( { rotation: endRotation }, 600 ).start();
/*
                
              //TWEEN position

                tween = new TWEEN.Tween(camera.position).to(
                    {
                    x: target.x,
                    y: target.y + 3,
                    z: target.z
                    },
                    2000
                );
            
                tween.easing(TWEEN.Easing.Quadratic.Out);
                tween.start();
                tween.onUpdate(function () {
                    updateCameraOrbit();
                }.bind(this));
                tween.onComplete(function () {
                    updateCameraOrbit();
                }.bind(this));
*/

            }
          }
        }

        }
        });
      }
      
      
    });

          interactionManager.add(jehlan);
          interactionManager.update();        
    } );
  
//oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
// oooooooooooooooooooooooooo         oooooooooooooooooooooooooooooooooooooooooooooooooooooooo
function getPath(object) {
    const string = object.name + ' [' + object.type + ']';

    if (object.parent) {
      return getPath(object.parent) + ' > ' + string;
    } else {
      return string;
    }
  }


//////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////

//      CCCCCCCCCCC
//   CCCCC      CCCCCCC
//  CCCCC
//  CCCCC
//   CCCCC
//    CCCCCC         CCCCCCCCC
//      CCCCCCC   CCCCCC
//          CCCCCCCCCC
/*
const gridHelper = new THREE.GridHelper( 50, 50 );
gridHelper.position.y = - 1;
// scene.add( gridHelper );

const invisibleMaterial = new THREE.MeshBasicMaterial( { color: 0xff000000, wireframe: false, transparent: true } )


// Gobelin COllider
const colliderMesh0 = new THREE.Mesh(
	new THREE.BoxGeometry( 7, 8, 0.7 ),
//	new THREE.MeshNormalMaterial(),
invisibleMaterial,
);
colliderMesh0.position.set(0.0,0.0,0.0);
scene.add( colliderMesh0 );


/////////////////////////////////////////////
const colliderMesh1 = new THREE.Mesh(
	new THREE.BoxGeometry( 20, 0.5, 30 ),
//	new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMesh1.position.set(0.0,-5.0,0.0);//////////////////////
// scene.add( colliderMesh1 );
///////////////////////////////////////////////

const colliderMesh2 = new THREE.Mesh( 
	new THREE.BoxGeometry( 600, 150.0, 600 ),
//	new THREE.MeshBasicMaterial( { color: 0xff0ff0, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMesh2.position.set(0.0,-80.0,0.0);//////////////////////
// scene.add( colliderMesh2 );
///////////////////////////////////////////////


//0////walls
const colliderMesha = new THREE.Mesh(
	new THREE.BoxGeometry( 5, 500, 500 ),
//	new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMesha.position.set(-150.0,150.0,0.0);//////////////////////
// scene.add( colliderMesha );

//1///////////////////////////////////////////
const colliderMeshb = new THREE.Mesh(
	new THREE.BoxGeometry( 5, 500, 500 ),
//	new THREE.MeshBasicMaterial( { color: 0x00ffaaa0, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMeshb.position.set(150.0,150.0,0.0);//////////////////////
 //scene.add( colliderMeshb );

//2///////////////////////////////////////////
const colliderMeshc = new THREE.Mesh(
	new THREE.BoxGeometry( 500, 500, 5 ),
//	new THREE.MeshBasicMaterial( { color: 0x0000ffa0, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMeshc.position.set(-0.0,150.0,150.0);//////////////////////
// scene.add( colliderMeshc );

//3///////////////////////////////////////////
const colliderMeshd = new THREE.Mesh(
	new THREE.BoxGeometry( 500, 500, 5 ),
//	new THREE.MeshBasicMaterial( { color: 0xffffa0, wireframe: false, transparent: true } )
invisibleMaterial
);
colliderMeshd.position.set(0.0,150.0,-150.0);//////////////////////
// scene.add( colliderMeshd );
/////////////////////////////////////////////
*/

/*
cameraControls.colliderMeshes.push( colliderMesh0 );
cameraControls.colliderMeshes.push( colliderMesh1 );
cameraControls.colliderMeshes.push( colliderMesh2 );
cameraControls.colliderMeshes.push( colliderMesha );
cameraControls.colliderMeshes.push( colliderMeshb );
cameraControls.colliderMeshes.push( colliderMeshc );
cameraControls.colliderMeshes.push( colliderMeshd );
*/

/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////

 // renderer.render( scene, camera );

 var moveEnabled = false
 scene.background = new THREE.Color( 0x544455 );

 var TextureLoader = new THREE.TextureLoader();
 var backgroundTexture = TextureLoader.load( './textures/icons/gradient01.svg' );
scene.background = backgroundTexture;
    
//renderer.setClearColor(0x000000, 0)


   //raycast
   let raycaster = new THREE.Raycaster();
   var mousePos1 = new THREE.Vector3()
   raycaster.setFromCamera(mouse, camera);
   var intersects = raycaster.intersectObjects(scene.children, true);
  
   
// AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA           AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA             AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA               AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA           AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA             AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA               AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        


// tour

const curve = new THREE.CatmullRomCurve3( [
  new THREE.Vector3(   0, 40, 40 ),

	new THREE.Vector3( -2,   7, -79 ), // no end (left)
	new THREE.Vector3(  -67,   26, -15 ), // Space Desert
	new THREE.Vector3( 1,   14, 69 ), // noname
  new THREE.Vector3(  35,   26, 15 ), // Space Desert
//  new THREE.Vector3(  11.5,   3, 3 ), // Space Desert
  
//	new THREE.Vector3(   0, 10, 10 ),
] );
const points = curve.getPoints( 50 );
const pathMesh = new THREE.Line(
	new THREE.BufferGeometry().setFromPoints( points ),
	new THREE.LineBasicMaterial( { color: 0xff0000 } )
);
// scene.add( pathMesh );


const moveToStartPoint = () => {

	curve.getPoint ( 0, _tmp );
	cameraControls.setLookAt( _tmp.x, _tmp.y, _tmp.z, 0, 0, 0, true );
//  cameraControls.setLookAt( -67,   26, -15, 0, 0, 0, true );

};


const _tmp = new THREE.Vector3();
const animationProgress = { value: 0 };
const pathAnimation = gsap.fromTo(
  animationProgress,
  {
    value: 0,
  },
  {
    value: 1,
    duration: 6,
		paused: true,
    onUpdateParams: [ animationProgress ],
    onUpdate( { value } ) {

			curve.getPoint ( value, _tmp );
			const cameraX = _tmp.x;
			const cameraY = _tmp.y;
			const cameraZ = _tmp.z;
			const lookAtX = 0;
			const lookAtY = 0;
			const lookAtZ = 0;

			cameraControls.setLookAt(
				cameraX,
				cameraY,
				cameraZ,
				lookAtX,
				lookAtY,
				lookAtZ,
				false
			);

    },
		onStart() {

			cameraControls.enabled = false;
      pause = true
		},
		onComplete() {

			cameraControls.enabled = true;
      muteBtnButton.style.display = "block"
      reset.style.display = "block"  
      home.style.display = "block"
    //  move.style.display = "none"
      aboutButton.style.display = "block"

      
      cameraControls.reset( false )
      cameraControls.rotate( 115 * THREE.MathUtils.DEG2RAD, 0, false )
      cameraControls.moveTo(  11.5,   8, 10 , false)
      pause = false
		}
  }
);


// AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA           AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA             AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA               AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA            AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA          AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA    AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA  

// AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA           AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA             AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA               AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA            AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA          AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA    AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA   
/*
readyAfterLoad = false
         window.setTimeout(() =>
         {
             sceneReady = true


         }, 500)
*/
function cameraControlOnStart() {


  muteBtnButton.style.display = "none"
  reset.style.display = "none"  
  move.style.display = "none"
  aboutButton.style.display = "none"

     //   cameraControls.moveTo( 20,4,4, true )
   //  cameraControls.moveTo( 0,0,0, true )

   cameraControls.truck( 0, 0, true ) 
   cameraControls.rotate( 0, -1.1 * THREE.MathUtils.DEG2RAD, true)   
   cameraControls.dolly(-48,false) 
     
 //    cameraControls.truck( 0, -200, true ) 

   //   cameraControls.rotateTo( THREE.Math.degToRad(90), THREE.Math.degToRad(90), true );
  //   cameraControls.forward( -150, false )
  //   cameraControls.setOrbitPoint( 50, 0, 0 ) 
   
// dolly 

//cameraControls.minDistance(0)
cameraControls.maxDistance = 900
//cameraControls.dollySpeed()
//cameraControls.dollyToCursor()

  //   cameraControls.zoom( -camera.zoom / 15.001, true )
     // cameraControls.rotate( THREE.Math.degToRad(-90), 0, true )
  

     //cameraControls.rotate( 360 * THREE.MathUtils.DEG2RAD, 0, true 
   // rotate naklon
   //  cameraControls.rotate( 0, 20 * THREE.MathUtils.DEG2RAD, true   
  
 //cameraControls.truck(  1,  0, true)
 // cameraControls.truck( -1, -1, true )
        if (readyAfterLoad == true)
      //  console.log("readyAfterLoad == true")

         window.setTimeout(() =>
         {
             sceneReady = true


         }, 500)
}

function afterLoeadEnded() {
  welcome.style.display = "block"
  blink.style.display = "block"


}

// tour
var started = true
document.addEventListener('mousedown', (event) => {
  
  if (sceneReady && started) {
    started = false
    welcome.style.display = "none"
    blink.style.display = "none"  
    cameraControls.dolly(600,true)
  //  console.log("document.addEventListener('mousedown', (e")
    
    window.setTimeout(() =>
    {
      disableAutoRotate = true
        cameraControls.reset(false)
        cameraControls.moveTo( 0,2,0, false )

        //  PATH ANIMATION
        moveToStartPoint()

       //   cameraControls.removeEventListener( 'rest', onRest );
    }, 2500)

    window.setTimeout(() =>
    {
      //  PATH ANIMATION
      moveToStartPoint()

    }, 5000)

    pathAnimation.play( 0 )
    
  }
  
  //cameraControls.reset(false)

})


// Exclusive control for user dragging
let userDragging = false;
let disableAutoRotate = false;
/*
const onRest = () => {

	cameraControls.removeEventListener( 'rest', onRest );
	userDragging = false;
	disableAutoRotate = false;

}

cameraControls.addEventListener( 'controlstart', () => {

	cameraControls.removeEventListener( 'rest', onRest );
	userDragging = true;
	disableAutoRotate = false;

} );
cameraControls.addEventListener( 'controlend', () => {

	if ( cameraControls.active ) {

		cameraControls.addEventListener( 'rest', onRest );

	} else {

		onRest();

	}

} );

//
cameraControls.addEventListener( 'transitionstart', () => {

	if ( userDragging ) return;

	disableAutoRotate = false;
//	cameraControls.addEventListener( 'rest', onRest );

} );
*/
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////


 ui()
// INTRO()
 // initSky();
 // mraky()
 // fireflies() 
 // createParticleSystemDistort(scene);
 let roomRot = 0
 var counter1 = 0
 var side = 0
 anim()
 


function anim () {
	const delta = clock.getDelta();
  const elapsedTime = clock.getElapsedTime()
	const updated = cameraControls.update( delta );

  if ( ! disableAutoRotate ) {

		cameraControls.azimuthAngle += 20 * delta * THREE.MathUtils.DEG2RAD;

	}
  // if ( elapsed > 30 ) { return; }

 // modeDiv.innerHTML = '<span style="color: #11ff11"> EXPLORING = ' + exploring + ' | PAUSE = ' + pause + ' | movSpeed = ' + movSpeed + ' | moveEnabled = ' + moveEnabled +' </span>' ;
  //  cameraControls.enabled  moveEnabled

  // Update passes
  // displacementPass.material.uniforms.uTime.value = elapsedTime
  // Fireflies
  firefliesMaterial.uniforms.uTime.value = elapsedTime

 // Update materials
   portalLightMaterial.uniforms.uTime.value = elapsedTime
   portalLightMaterial1.uniforms.uTime.value = elapsedTime
   portalLightMaterial2.uniforms.uTime.value = elapsedTime
   portalLightMaterial3.uniforms.uTime.value = elapsedTime

  if (side == 0)
    counter1 += 0.0005
  if (side == 1)
    counter1 -= 0.0005

if (counter1 > 0.45) {
//  counter1 = 0.01
  side = 1
} 
if (counter1 < 0.4) {
  //  counter1 = 0.01
    side = 0
  } 

  renderer.toneMappingExposure = counter1;


 //  roomRot += 0.5
 //  room.rotateX(THREE.Math.degToRad(roomRot));
 
/*
 if(mixerDoor)
  {
    mixerDoor.update(delta)
  }
*/
 if(portalMixer)
  {
    portalMixer.update(delta)
  }
  if(mixerJehlan)
  {
    mixerJehlan.update(delta)
  }

//DISTORT//DISTORT//DISTORT
//DISTORT//DISTORT//DISTORT
/*
  if (intersects.length>0) {
   //   console.log("Interesct !!!!!!!!!: " + intersects[0].point)
   //   console.log("Interesct point XXXXXX: " + intersects[0].point.x)
  //    console.log("Interesct point YYYYYY: " + intersects[0].point.y)
  //    console.log("Interesct point ZZZZZZ: " + intersects[0].point.z)
      
      mousePos1.x = intersects[0].point.x * 1.5 - 5.
      mousePos1.y = intersects[0].point.y * 1.5 + 5.
      mousePos1.z = intersects[0].point.z * 0.8+ 5 


   // distortMat.uniforms.mousePos.value = intersects[0].point
   distortMat.uniforms.mousePos.value = mousePos1
  }  else {
    //  distortMat.uniforms.mousePos.value = (0.0001, 0.001, 0.001)
  }
  //DISTORT
  distortMat.uniforms.time.value += 0.001;
    waveMat.uniforms.time.value += 0.001;
*/

/*
  // GOBELIN
  if (exploring) {
    if (rotGobRight == true) {
      console.log("rot right")
     cameraControls.rotate( 5 * THREE.MathUtils.DEG2RAD, 0, true )
  }
  if (rotGobLeft == true) {
    console.log("rot left")
    cameraControls.rotate( -5 * THREE.MathUtils.DEG2RAD, 0, true )
  }
  }


  if (plusGob == true) {
    cameraControls.zoom( camera.zoom / 10.001, true )
    console.log(camera.zoom)
   } 

   if (minusGob == true) {
    cameraControls.zoom( -camera.zoom / 10.001, true )
    console.log(camera.zoom)
   } 
   */
  
  if (!exploring) {
     if (moveForward) {
        cameraControls.forward(   10.5 * movSpeed * delta, false )
     //   cameraControls.dolly(  0.1* movSpeed, true )
     //   effectController.turbidity += 0.5
    }
   else if (moveBackward) {
      cameraControls.forward(   -6.5 * movSpeed * delta, false )
    //  cameraControls.dolly(  -0.1* movSpeed, true )
   //   effectController.turbidity += 0.5
    }
    else if (moveLeft) {
      cameraControls.truck(  -0.5* movSpeed,  0, true)
    //  cameraControls.moveLeft(   6.5 * movSpeed * delta, false )
  //   effectController.turbidity += 0.5
    }
    else if (moveRight) {
      cameraControls.truck(  0.5* movSpeed,  0, true)
    //  cameraControls.moveRight(   6.5 * movSpeed * delta, false )
    //   effectController.turbidity += 0.5
    }
    
  }

	// if ( elapsedTime > 130 ) { return; }

	requestAnimationFrame( anim );


  // Smoke Particles
  [].forEach.call(smokeParticles, sp => {
    sp.rotation.z += delta * 0.2;
});


      // Render
    // renderer.render(scene, camera)
    effectComposer.render()
	//	console.log( 'rendered' );

	if ( updated ) {
    interactionManager.update();
	}

}


// AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA           AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA             AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA               AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA            AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA          AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA        AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA        
// AAAAA    AAAAA     AAAAA     AAAAA     AAAAA     AAAAA     AAAAA  

/////////////////////////////////////////////////////////////////



/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////
///////                                        / ////////
////////    //    //       ////             /////////////
////////    //    //                         ////////////
////////    //    //       ////              ////////////
////////    //    //       ////              ////////////
////////    //    //       ////              ////////////
///////       ////         ////              ////////////
///////                                       ///////////
//////////////////////////////////////////////////////////
function ui() {
}


 //home
 home.src = "./textures/icons/home.svg";
 home.width = "50";

 home.addEventListener('mouseover', (event) => {
  home.src = "./textures/icons/homeHover.svg";
 // exploring = true
 });
 home.addEventListener('mouseout', (event) => {
  home.src = "./textures/icons/home.svg";
 // exploring = false
 });
 home.onmousedown = function() {
  home.src = "./textures/icons/home.svg";
 // if (exploring == false) {
     AudioClick()
    // var myWindow = window.open("https://textile.gallery/", "_self");
     homeModal.style.display = "block"
 //  }
 }
 home.onmouseup = function() {
  home.src = "./textures/icons/fihomeHovert.svg";
   if (exploring == true) {
   
   }
 }

/*
sec0.style.display = "none"
sec1.style.display = "none"
sec2.style.display = "none"
sec3.style.display = "none"
sec4.style.display = "none"  
*/

  // Exploring Buttons
  exploringBox.style.display = "none";
  // Exploring Right
  rightBox.style.display = "none";

  titleBox.style.display = "blcok";

  plusBtn.src = "./textures/icons/plus.svg";
  plusBtn.width = "50";


  minusBtn.src = "./textures/icons/minus.svg";
  minusBtn.width = "50";


  //left
  leftBtn.src = "./textures/icons/left.svg";
  leftBtn.width = "50";

  leftBtn.addEventListener('mouseover', (event) => {
    leftBtn.src = "./textures/icons/leftClick.svg";
  });
  leftBtn.addEventListener('mouseout', (event) => {
    leftBtn.src = "./textures/icons/left.svg";
  });
  leftBtn.onmousedown = function() {
    leftBtn.src = "./textures/icons/leftHover.svg";
    if (exploring == true) {
      AudioClick()
      rotGobLeft = true
    }
  }
  leftBtn.onmouseup = function() {
    leftBtn.src = "./textures/icons/leftHover.svg";
    if (exploring == true) {
      rotGobLeft = false
    }
  }

  // right
  rightBtn.src = "./textures/icons/right.svg";
  rightBtn.width = "50";

  rightBtn.addEventListener('mouseover', (event) => {
    rightBtn.src = "./textures/icons/rightClick.svg";
  });
  rightBtn.addEventListener('mouseout', (event) => {
    rightBtn.src = "./textures/icons/right.svg";
  });
  rightBtn.onmousedown = function() {
    rightBtn.src = "./textures/icons/rightHover.svg";
    if (exploring == true) {
      AudioClick()
      rotGobRight = true
    }
  }
  rightBtn.onmouseup = function() {
    rightBtn.src = "./textures/icons/rightHover.svg";
    if (exploring == true) {
      rotGobRight = false
    }
  }

  // exit
  exitBtn.src = "./textures/icons/exit.svg";
  exitBtn.width = "50";

  exitBtn.addEventListener('mouseover', (event) => {
    exitBtn.src = "./textures/icons/exitHover.svg";
  });
  exitBtn.addEventListener('mouseout', (event) => {
    exitBtn.src = "./textures/icons/exit.svg";
  });


  exitBtn.onclick = function() {
    exitBtn.src = "./textures/icons/exitClick.svg";

    bottom.style.display = "block";

  //  scene.add(modelScene)
    cameraControls.enabled = true;

    if (exploring == true) {
      AudioClick()
      exploring = false
      pause = false

      cameraControls.lerpLookAt( -5, -5, -5, -5, -5, -5, -5, 2, 5, -1, 0, 0, Math.random(), true )

      exploringBox.style.display = "none";
      rightBox.style.display = "none";
      titleBox.style.display = "block";


      rgbShiftPass.enabled = false
      unrealBloomPass.enabled = true
      
   
    //  gobelin.position.set(0.0,0.0,0.0);
    //  gobelin.rotation.set(0,0,0);

    }
    // I prefer to swap the mouse controls, but most examples out there don't:
    // controlsOrbit.enabled = true;
    /*
    controlsOrbit.mouseButtons = {
      ORBIT: THREE.MOUSE.LEFT,
      ZOOM: THREE.MOUSE.MIDDLE,
      PAN: THREE.MOUSE.LEFT
    };
    controlsOrbit.enableDamping = true; // For that slippery Feeling
    controlsOrbit.dampingFactor = 0.5; // Needs to call update on render loop 
    controlsOrbit.rotateSpeed = 0.08; // Rotate speed
    controlsOrbit.autoRotate = false; // turn this guy to true for a spinning camera
    controlsOrbit.autoRotateSpeed = 0.58; // 30
    controlsOrbit.maxPolarAngle = Math.PI/2; // Don't let to go below the ground
  // < Orbit Controls
  */
  }

/*

  var plusGob = false
  var minusGob = false

  //minus
  minusBtn.addEventListener('mouseover', (event) => {
    minusBtn.src = "./textures/icons/minus.svg";
  });
  minusBtn.addEventListener('mouseout', (event) => {
    minusBtn.src = "./textures/icons/minus.svg";
  });
  minusBtn.onmousedown = function() {
    minusBtn.src = "./textures/icons/minusHover.svg";
    if (exploring == true) {
      AudioClick()
      minusGob = true
    }
  }
  minusBtn.onmouseup = function() {
    minusBtn.src = "./textures/icons/minus.svg";
    if (exploring == true) {
      minusGob = false
    }
  }
  //plus
  plusBtn.addEventListener('mouseover', (event) => {
    plusBtn.src = "./textures/icons/plus.svg";
  });
  plusBtn.addEventListener('mouseout', (event) => {
    plusBtn.src = "./textures/icons/plus.svg";
  });
  plusBtn.onmousedown = function() {
    plusBtn.src = "./textures/icons/plusHover.svg";
    if (exploring == true) {
      AudioClick()
      plusGob = true
    }
  }
  plusBtn.onmouseup = function() {
    plusBtn.src = "./textures/icons/plus.svg";
    if (exploring == true) {
      plusGob = false
    }
  }
*/

  //bottom 
  bottom.style.display = "block";

  //reset 
  reset.src = "./textures/icons/reset.svg";
  reset.width = "50";

  reset.addEventListener('mouseover', (event) => {
    reset.src = "./textures/icons/reset_hover.svg";
    exploring = true
  });
  reset.addEventListener('mouseout', (event) => {
    reset.src = "./textures/icons/reset.svg";
    exploring = false
  });
  reset.onmousedown = function() {
    reset.src = "./textures/icons/reset.svg";
  // if (exploring == false) {
      AudioClick()
      cameraControls.reset( true )
      cameraControls.moveTo(  11.5,   8, 10 , false)
      cameraControls.rotate( 105 * THREE.MathUtils.DEG2RAD, 0, false )

  //  }
  }
  reset.onmouseup = function() {
    reset.src = "./textures/icons/reset_hover.svg";
    if (exploring == true) {
    
    }
  }

  //move 
  var move = document.getElementById("move");

  move.src = "./textures/icons/move_hover.svg";
  move.width = "50";

  move.addEventListener('mouseover', (event) => {
    move.src = "./textures/icons/move_hover.svg";
    exploring = true
  });
  move.addEventListener('mouseout', (event) => {
    move.src = "./textures/icons/move.svg";
    exploring = false
    if (moveEnabled == true)
    move.src = "./textures/icons/move_hover.svg";
    else
    move.src = "./textures/icons/move.svg";
  });
  move.onmousedown = function() {
    move.src = "./textures/icons/move.svg";
      AudioClick()
      moveEnabled = !moveEnabled

  }
  move.onmouseup = function() {
    move.src = "./textures/icons/move_hover.svg";

  }

  //fit 
  var fit = document.getElementById("fit");
  fit.src = "./textures/icons/fit.svg";
  fit.width = "50";

  fit.addEventListener('mouseover', (event) => {
    fit.src = "./textures/icons/fit_hover.svg";
  // exploring = true
  });
  fit.addEventListener('mouseout', (event) => {
    fit.src = "./textures/icons/fit.svg";
  // exploring = false
  });
  fit.onmousedown = function() {
    fit.src = "./textures/icons/fit.svg";
  // if (exploring == false) {
      AudioClick()
      cameraControls.fitToBox( gobelin, true )
  //  }
  }
  fit.onmouseup = function() {
    fit.src = "./textures/icons/fit_hover.svg";
    if (exploring == true) {
    
    }
  }





/*
  //speedUp 
  speedUp.style.display = "none";
  speedUp.src = "./textures/icons/speedUp.svg";
  speedUp.width = "50";
  speedUp.addEventListener('mouseover', (event) => {
    speedUp.src = "./textures/icons/speedUp_hover.svg";
    exploring = true
  });
  speedUp.addEventListener('mouseout', (event) => {
    speedUp.src = "./textures/icons/speedUp.svg";
    exploring = false
  });
  speedUp.onmousedown = function() {
    speedUp.src = "./textures/icons/speedUp.svg";
  // if (exploring == false) {
      AudioClick()
      movSpeed += 0.1
  //  }
  }
  speedUp.onmouseup = function() {
    speedUp.src = "./textures/icons/speedUp_hover.svg";
    if (exploring == true) {
    //  minusGob = false
    }
  }
*/
/*
  //speedDown
  speedDown.style.display = "none";
  speedDown.src = "./textures/icons/speedDown.svg";
speedDown.width = "50";
  speedDown.addEventListener('mouseover', (event) => {
    speedDown.src = "./textures/icons/speedDown_hover.svg";
    exploring = true
  });
  speedDown.addEventListener('mouseout', (event) => {
    speedDown.src = "./textures/icons/speedDown.svg";
    exploring = false
  });
  speedDown.onmousedown = function() {
    speedDown.src = "./textures/icons/speedDown.svg";
  // if (exploring == false) {
      AudioClick()
      movSpeed -= 0.1
  //  }
  }
  speedDown.onmouseup = function() {
    speedDown.src = "./textures/icons/speedDown_hover.svg";
    if (exploring == true) {
    //  minusGob = false
    }
  }
*/

  //2k

  t2k.style.display = "none";
t4k.style.display = "none";


  t2k.width = "50";
  t4k.width = "50";


    t2k.src = "./textures/icons/2k_hover.svg";
    t4k.src = "./textures/icons/4k.svg";



  t2k.addEventListener('mouseover', (event) => {
    if (resolution == 0)
    t2k.src = "./textures/icons/2k_hover.svg";
    else 
    t2k.src = "./textures/icons/2k.svg";
  // exploring = true
  });
  t2k.addEventListener('mouseout', (event) => {
    if (resolution != 0)
    t2k.src = "./textures/icons/2k.svg";
  // exploring = false
  });
  t2k.onmousedown = function() {
    t2k.src = "./textures/icons/2k.svg";
    if (exploring == true) {
      AudioClick()

      resolution = 0
      t2k.src = "./textures/icons/2k_hover.svg";
      t4k.src = "./textures/icons/4k.svg";


    }
  }
  t2k.onmouseup = function() {
    t2k.src = "./textures/icons/2k_hover.svg";
    if (exploring == true) {
    //  minusGob = false
    }
  }

  //4k
  t4k.addEventListener('mouseover', (event) => {
    if (resolution == 1)
    t4k.src = "./textures/icons/4k_hover.svg";
    else
    t4k.src = "./textures/icons/4k.svg";
  //  exploring = true
  });
  t4k.addEventListener('mouseout', (event) => {
    if (resolution != 1)
    t4k.src = "./textures/icons/4k.svg";
  //  exploring = false
  });
  t4k.onmousedown = function() {
    t4k.src = "./textures/icons/4k.svg";
    if (exploring == true) {
      AudioClick()

      resolution = 1
      t2k.src = "./textures/icons/2k.svg";
      t4k.src = "./textures/icons/4k_hover.svg";

    }
  }
  t4k.onmouseup = function() {
    t4k.src = "./textures/icons/4k_hover.svg";
    if (exploring == true) {
    //  minusGob = false
    }
  }

  /*
  MODAL
  */

  // Get the modal
  infoModal.style.display = "none";


  
  // Get the button that opens the modal
  var muted = true

  // When the user clicks on the button, open the modal
  btn.onclick = function() {
    infoModal.style.display = "block";
  //  pause = true;
    AudioClick()
  }

  // Get the <span> element that closes the modal
  

  span.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  span1.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  span2.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  // When the user clicks on <span> (x), close the modal
  span3.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  span4.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  span5.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }  
  span6.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }

  // desert
  goto0.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  goto1.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
   // console.log('Exit Modal')
    AudioClick()
  }
  //noname
  goto2.onclick = function() {
    noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
  goto3.onclick = function() {
    homeModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    pause = false;
  //  console.log('Exit Modal')
    AudioClick()
  }
//noend
goto4.onclick = function() {
  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
//  console.log('Exit Modal')
  AudioClick()
}
goto5.onclick = function() {
  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
 // console.log('Exit Modal')
  AudioClick()
}
//techno
goto6.onclick = function() {
  cameraControls.forward(   -16.5 , false )  
  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
 // console.log('Exit Modal')
  AudioClick()
}
goto7.onclick = function() {
  cameraControls.forward(   -16.5 , true )  
  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
//  console.log('Exit Modal')
  AudioClick()
}
//Intro
goto8.onclick = function() {
  cameraControls.forward(   -16.5 , false )  

  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
//  console.log('Exit Modal')
  AudioClick()
}
goto9.onclick = function() {
  cameraControls.forward(   -16.5 , true )  

  noendModal.style.display = "none";
    desertModal.style.display = "none";
    nonameModal.style.display = "none";
    infoModal.style.display = "none";
    homeModal.style.display = "none";
    introModal.style.display = "none";
  pause = false;
//  console.log('Exit Modal')
  AudioClick()
}


window.onclick = function(event) {
  if (event.target == infoModal) {
    infoModal.style.display = "none";

  } else if (event.target == desertModal) {
    desertModal.style.display = "none";
  }else if (event.target == noendModal) {
    noendModal.style.display = "none";
  }else if (event.target == nonameModal) {
    nonameModal.style.display = "none";
  }
} 

  AudioBackground();
  /*
  AUDIO
  */
  function AudioClick() {
    const listener = new THREE.AudioListener();
    camera.add( listener );
    const sound = new THREE.Audio( listener );
    const audioLoader = new THREE.AudioLoader();
    audioLoader.load( './audio/h1.wav', function( buffer ) {
        sound.setBuffer( buffer );
        sound.setLoop( false );
        sound.setVolume( 0.1 );
        sound.play();
  });

  }

  /* MUTE Toggle*/
  muteBtnButton.src = "./textures/icons/muteButtonMuted.svg";
  muteBtnButton.width = "50";

  aboutButton.src = "./textures/icons/about.svg";
  aboutButton.width = "50";


  // about hover
  aboutButton.addEventListener('mouseover', (event) => {
    exploring = true
    aboutButton.src = "./textures/icons/aboutHover.svg";
  // console.log("hover about")
  });
  aboutButton.addEventListener('mouseout', (event) => {
    exploring = false
    aboutButton.src = "./textures/icons/about.svg";
  // console.log("hover about")
  });

  //mute hover
  muteBtnButton.addEventListener('mouseover', (event) => {
    exploring = true
    if (!muted)
    muteBtnButton.src = "./textures/icons/muteButtonMutedHover.svg";
    else
    muteBtnButton.src = "./textures/icons/muteButtonHover.svg";
  // console.log("hover mute")
  });
  muteBtnButton.addEventListener('mouseout', (event) => {
    exploring = false
    if (muted)
    muteBtnButton.src = "./textures/icons/muteButton.svg";
    else
    muteBtnButton.src = "./textures/icons/muteButtonMuted.svg";
  //  console.log("hover mute")
  });
  /*
  muteBtnButton.addEventListener('click', function(){
    muteBtnButton.src = "./textures/particles/whitePuff00.png";
    console.log("MUTE BUTTOOOON")
  });
  */

  function AudioBackground() {
    const listener = new THREE.AudioListener();
    camera.add( listener );

    const sound = new THREE.Audio( listener );

    const audioLoader = new THREE.AudioLoader();
    audioLoader.load( './audio/b3.mp3', function( buffer ) {
        sound.setBuffer( buffer );
        sound.setLoop( true );
        sound.setVolume( 0.1 );
      //  sound.play(); 

      //start
      if (!muted) {
        muteBtnButton.src = "./textures/icons/muteButton.svg";
        AudioClick()
        sound.play();
      //  console.log('mute')
        muted = true
        window.setTimeout(() =>
      {
       //   sceneReady = true
      }, 500)
      } else if (muted) {
        muteBtnButton.src = "./textures/icons/muteButtonMuted.svg";
        AudioClick()
        sound.pause();
      //  console.log('unmute')
        muted = false
        window.setTimeout(() =>
      {
        //  sceneReady = true
      }, 2000)
      }

      //click
        mutebtn.onclick = function() {
          if (!muted) {
            muteBtnButton.src = "./textures/icons/muteButton.svg";
            AudioClick()
            sound.play();
          //  console.log('mute')
            muted = true
            window.setTimeout(() =>
          {
         //     sceneReady = true
          }, 500)
          } else if (muted) {
            muteBtnButton.src = "./textures/icons/muteButtonMuted.svg";
            AudioClick()
            sound.pause();
          //  console.log('unmute')
            muted = false
            window.setTimeout(() =>
          {
          //    sceneReady = true
          }, 2000)
          }     
        }
  });
  }



/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////





